import { ENTITY_CONSTANTS } from '../constants/entityConstants';

export const REPORT_DATASOURCE_KEYS = {
    workspace: 'workspace',
    production: 'production',
    resource: 'resource',
    shortlistLineItems: 'shortlistLineItems'
} as const;

const convertFirstCharacterToLowercase = <T extends string>(value: T): Uncapitalize<T> => {
    return `${value.charAt(0).toLowerCase()}${value.slice(1)}` as Uncapitalize<T>;
};

export const REPORT_ENTITIES = {
    resource: convertFirstCharacterToLowercase(ENTITY_CONSTANTS.resource),
    production: convertFirstCharacterToLowercase(ENTITY_CONSTANTS.production),
    shortlistLineItem: convertFirstCharacterToLowercase(ENTITY_CONSTANTS.shortlistLineitem)
} as const;
